import { render } from "./TopBarBack.vue?vue&type=template&id=654a0b8e"
import script from "./TopBarBack.vue?vue&type=script&lang=js"
export * from "./TopBarBack.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__